import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import ExternalLinkCreationPanel from '../../components/ExternalLinkCreationPanel';

const mapStateToProps = (state: StoreState) => {
	const { externalLinkCreationPanel: { isOpen, fields, errors } } = state;
	return {
		isOpen,
		fields,
		errors,
	};
};

export default connect(mapStateToProps)(ExternalLinkCreationPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ExternalLinkCreationPanel/index.ts